var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallDanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9128 8.38257L15.9322 6.3632C17.1961 5.09927 17.1961 3.046 15.9322 1.78208L11.6223 6.09201V3.23971C11.6223 1.44794 10.1695 0 8.38257 0V6.09201L6.3632 4.07264C5.09927 2.80872 3.046 2.80872 1.78208 4.07264L6.09201 8.38257H3.23971C1.44794 8.38257 0 9.83535 0 11.6223H6.08717L4.0678 13.6416C2.80387 14.9056 2.80387 16.9588 4.0678 18.2228L8.37772 13.9128V16.7651C8.37772 18.5569 9.83051 20.0048 11.6174 20.0048V13.9128L13.6368 15.9322C14.9007 17.1961 16.954 17.1961 18.2179 15.9322L13.908 11.6223H16.7603C18.5521 11.6223 20 10.1695 20 8.38257H13.9128Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDanceIcon);
export default __webpack_public_path__ + "static/media/smallDanceIcon.31e6d506cc2fc71a88b62ff75b31fd61.svg";
export { ForwardRef as ReactComponent };